import { createStore } from 'redux';
import initialState from './storeConst';
import rootReducer from './root-reducer';

// const middleware = []

// Enable this for Redux Logs during dev
// if (process.env.NODE_ENV === 'development') middleware.push(logger);

// const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
  rootReducer,
  initialState
  //  composeEnhancer(applyMiddleware(...middleware))
);

export default store;
